import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	img: {
		width: 64
	}
})

export default useStyles
